module.exports = __webpack_public_path__ + "img/tg_03 (8).a5722b10.jpg";